<template>
  <!-- 底栏 -->
  <div>
    1
  </div>
</template>
<script>
import Bus from '@/api/bus'
import Vue from 'vue'
import { getImagePage } from '@/api/home'
import { getDomain, getDomainLogo } from '@/api/cookies'
import { getInfo } from '@/api/cookies'
// import { JuxueU } from '@/api/JuxueU'
// const juxueU = new JuxueU()
export default {
  data() {
    return {
      path: '/',

      logo: '',
      copyright: {}
    }
  },

  async created() {
    this.path = window.location.pathname
    this.userInfo = getInfo()
    this.logo = getDomainLogo()
    this.copyright = getDomain()

  },
  mounted() {

  },
  methods: {
    gopage(path, type) {
      if (this.path == path) {
        return
      }
      if (type) {
        // window.open(path, "_blank");
        this.$router.push(path)
      } else {
        /* this.$router.push(path); */
        // window.open(path, "_blank");
        this.$router.push(path)
      }
    },

  }
}
</script>
<style lang="less" scoped></style>
